// import React, { useEffect, useState } from "react";
// import CustomQuestionPaper from "./CustomQuestionPaper";

// const QuestionPaper = ({ selectedClass, selectedSubject, selectedChapter,setPrintContent }) => {
//   const [filteredQuestions, setFilteredQuestions] = useState([]);
//   const [chapterName, setChapterName] = useState("");
//   const [selectedQuestions, setSelectedQuestions] = useState({});
//   const [copiedImage, setCopiedImage] = useState("");

//   const handleImageClick = (imageUrl, category) => {
//     const formattedQuestion = {
//       question: "",
//       imgUrl: imageUrl,
//       options: [],
//     };

//     setSelectedQuestions((prevSelectedQuestions) => {
//       const updatedSelectedQuestions = { ...prevSelectedQuestions };

//       if (updatedSelectedQuestions.hasOwnProperty(category)) {
//         updatedSelectedQuestions[category].push(formattedQuestion);
//       } else {
//         updatedSelectedQuestions[category] = [formattedQuestion];
//       }
//       return updatedSelectedQuestions;
//     });
//     setCopiedImage(imageUrl);
//   };

//   const handleQuestionSelection = (categoryName, question) => {
//     const formattedQuestion = {
//       question: `${question.question}`,
//       options: question.options,
//       correctAnswer: question.correctAnswer,
//     };

//     const isQuestionSelected = selectedQuestions[categoryName]?.some(
//       (selectedQuestion) =>
//         selectedQuestion.question === formattedQuestion.question
//     );

//     if (!isQuestionSelected) {
//       setSelectedQuestions((prevSelectedQuestions) => {
//         const updatedQuestions = { ...prevSelectedQuestions };

//         if (updatedQuestions.hasOwnProperty(categoryName)) {
//           updatedQuestions[categoryName].push(formattedQuestion);
//         } else {
//           updatedQuestions[categoryName] = [formattedQuestion];
//         }

//         return updatedQuestions;
//       });
//     }
//   };
//   const uniqueSelectedQuestions = {};
//   for (const category in selectedQuestions) {
//     uniqueSelectedQuestions[category] = Array.from(
//       new Set(selectedQuestions[category].map((q) => JSON.stringify(q)))
//     ).map((strQ) => JSON.parse(strQ));
//   }

//   useEffect(() => {
//     fetch("https://raw.githubusercontent.com/Sandhyayadav77/antrikshtestpaperdata/main/questions.json")
//       .then(response => {
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return response.json();
//       })
//       .then(data => {
//         try {
//           const subjectData = data?.subjects.find(
//             (subject) => subject.name === selectedSubject
//           );
//           if (subjectData) {
//             const classData = subjectData.classes.find(
//               (classData) => classData.class === Number(selectedClass)
//             );

//             if (classData) {
//               const chapterData = classData.chapters.find((chapter) => {
//                 if (chapter.chapter === Number(selectedChapter)) {
//                   setChapterName(chapter.chapterName);
//                   return true; // Indicate that the chapter was found
//                 }
//                 return false; // Indicate that the chapter was not found
//               });
//               if (chapterData) {
//                 const questionsByCategory = {};
//                 chapterData.categories.forEach((category) => {
//                   const categoryQuestions = category.questions;
//                   if (categoryQuestions && categoryQuestions.length > 0) {
//                     questionsByCategory[category.categoryName] = categoryQuestions;
//                   }
//                 });

//                 setFilteredQuestions(questionsByCategory);
//               } else {
//                 setFilteredQuestions({}); // Set to an empty object if the chapter has no questions
//               }
//             } else {
//               setFilteredQuestions({}); // Set to an empty object if the class has no questions
//             }
//           } else {
//             setFilteredQuestions({}); // Set to an empty object if the subject has no questions
//           }
//         } catch (error) {
//           console.error("An error occurred while filtering questions:", error);
//           setFilteredQuestions({}); // Set to an empty object if an error occurs
//         }
//       })
//       .catch(error => {
//         console.error('There was a problem with the fetch operation:', error);
//       });
//   }, [selectedClass, selectedSubject, selectedChapter]);

//   return (
//     <>
//       <div className="max-sm:flex max-sm:flex-col grid grid-cols-2  gap-4 mx-5 my-3">
//         <div className="p-4">
//           {Object.keys(filteredQuestions).length > 0 && (
//             <>
//               <h2 className="text-2xl font-semibold mb-2 text-center">
//                 Question Paper
//               </h2>
//               <h2 className="text-2xl font-semibold mb-4 text-red-600 text-center underline">
//                 Chapter : {chapterName}
//               </h2>
//               {Object.keys(filteredQuestions).map((categoryName, index) => (
//                 <div key={index} className="mb-10">
//                   <h3 className="text-lg font-medium">{`Q${index+1} ${categoryName}`}</h3>
//                   <ul className="border ">
//                     {filteredQuestions[categoryName].map(
//                       (question, questionIndex) => (
//                         <li key={questionIndex} className="mt-2 ml-6">
//                           {/* Check if the question has hints */}
//                           {filteredQuestions[categoryName].hints &&
//                             filteredQuestions[categoryName].hints.length >
//                               0 && (
//                               <div className="mb-2">
//                                 <h4 className="font-medium">Hints:</h4>
//                                 <ul>
//                                   {filteredQuestions[categoryName].hints.map(
//                                     (hint, hintIndex) => (
//                                       <li key={hintIndex}>{hint}</li>
//                                     )
//                                   )}
//                                 </ul>
//                               </div>
//                             )}
//                           {question.question ? (
//                             <p
//                               className="font-medium"
//                               onClick={() =>
//                                 handleQuestionSelection(categoryName, question)
//                               }
//                               style={{ cursor: "pointer" }}
//                             >
//                               Q {question.index}: {question.question}
//                             </p>
//                           ) : question.imgUrl ? (
//                             <div
//                               className="mt-2"
//                               onClick={() =>
//                                 handleImageClick(question.imgUrl, categoryName)
//                               }
//                             >
//                               <img
//                                 src={question.imgUrl}
//                                 alt="Image Description"
//                               />
//                             </div>
//                           ) : null}
//                           {question.options && question.options.length > 0 && (
//                             <div className="mt-2 flex justify-start items-start gap-5 flex-wrap">
//                               {question.options.map((option, optionIndex) => (
//                                 <label key={optionIndex} className="block mb-2">
//                                   <input
//                                     type="radio"
//                                     name={`question${questionIndex}`}
//                                     value={option}
//                                     className="mr-2"
//                                   />
//                                   {option}
//                                 </label>
//                               ))}
//                             </div>
//                           )}
//                         </li>
//                       )
//                     )}
//                   </ul>
//                 </div>
//               ))}
//             </>
//           )}
//         </div>
//         <div className="border-l border-gray-300 pl-4">
//         <CustomQuestionPaper setPrintContent={setPrintContent}
//             selectedQuestions={uniqueSelectedQuestions}
//            setSelectedQuestions={setSelectedQuestions}
//            />
//         </div>
//       </div>
//     </>
//   );
// };

// export default QuestionPaper;

// alter without fetch

import React, { useEffect, useState } from "react";
import questionsData from "../data/questions.json"; // Adjust the path as needed
import CustomQuestionPaper from "./CustomQuestionPaper";

const QuestionPaper = ({ selectedClass, selectedSubject, selectedChapter, setPrintContent }) => {
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [chapterName, setChapterName] = useState("");
  const [selectedQuestions, setSelectedQuestions] = useState({}); //
  const [copiedImage, setCopiedImage] = useState("");

  const handleImageClick = (imageUrl, category) => {
    const formattedQuestion = {
      question: "",
      imgUrl: imageUrl,
      options: [],
    };

    setSelectedQuestions((prevSelectedQuestions) => {
      const updatedSelectedQuestions = { ...prevSelectedQuestions };

      if (updatedSelectedQuestions.hasOwnProperty(category)) {
        updatedSelectedQuestions[category].push(formattedQuestion);
      } else {
        updatedSelectedQuestions[category] = [formattedQuestion];
      }
      return updatedSelectedQuestions;
    });
    setCopiedImage(imageUrl);
  };

  const handleQuestionSelection = (categoryName, question) => {
    const formattedQuestion = {
      question: `${question.question}`,
      options: question.options,
      correctAnswer: question.correctAnswer,
    };

    const isQuestionSelected = selectedQuestions[categoryName]?.some(
      (selectedQuestion) =>
        selectedQuestion.question === formattedQuestion.question
    );

    if (!isQuestionSelected) {
      setSelectedQuestions((prevSelectedQuestions) => {
        const updatedQuestions = { ...prevSelectedQuestions };

        if (updatedQuestions.hasOwnProperty(categoryName)) {
          updatedQuestions[categoryName].push(formattedQuestion);
        } else {
          updatedQuestions[categoryName] = [formattedQuestion];
        }

        return updatedQuestions;
      });
    }
  };
  const uniqueSelectedQuestions = {};
  for (const category in selectedQuestions) {
    uniqueSelectedQuestions[category] = Array.from(
      new Set(selectedQuestions[category].map((q) => JSON.stringify(q)))
    ).map((strQ) => JSON.parse(strQ));
  }

  //   console.log("uniqueSelectedQuestions", uniqueSelectedQuestions);
  //   console.log(selectedQuestions);
  // fetch("https://raw.githubusercontent.com/Sandhyayadav77/antrikshtestpaperdata/main/questions.json")
  // .then(response => {
  //   if (!response.ok) {
  //     throw new Error('Network response was not ok');
  //   }
  //   return response.json(); // This returns another Promise
  // })
  // .then(data => {
  //   console.log("data",data); // Now you can see the fetched data
  // })
  // .catch(error => {
  //   console.error('There was a problem with the fetch operation:', error);
  // });
  useEffect(() => {
    try {
      const subjectData = questionsData?.subjects.find(
        (subject) => subject.name === selectedSubject
      );
      if (subjectData) {
        const classData = subjectData.classes.find(
          (classData) => classData.class === Number(selectedClass)
        );

        if (classData) {
          const chapterData = classData.chapters.find((chapter) => {
            if (chapter.chapter === Number(selectedChapter)) {
              setChapterName(chapter.chapterName);
              return true; // Indicate that the chapter was found
            }
            return false; // Indicate that the chapter was not found
          });
          if (chapterData) {
            const questionsByCategory = {};
            chapterData.categories.forEach((category) => {
              const categoryQuestions = category.questions;
              // const questionsOptions = category.questionsOptions;
              // console.log(questionsOptions)
              if (categoryQuestions && categoryQuestions.length > 0) {
                questionsByCategory[category.categoryName] = categoryQuestions;
              }
            });

            setFilteredQuestions(questionsByCategory);
    // console.log("questionsByCategory",questionsByCategory)

          } else {
            setFilteredQuestions({}); // Set to an empty object if the chapter has no questions
          }
        } else {
          setFilteredQuestions({}); // Set to an empty object if the class has no questions
        }
      } else {
        setFilteredQuestions({}); // Set to an empty object if the subject has no questions
      }
    } catch (error) {
      console.error("An error occurred while filtering questions:", error);
      setFilteredQuestions({}); // Set to an empty object if an error occurs
    }
       // console.log(filteredQuestions)
  }, [selectedClass, selectedSubject, selectedChapter]);
  return (
    <>
    
      <div className="max-sm:flex max-sm:flex-col grid grid-cols-2  gap-4 mx-5 my-3">
        <div className="p-4">
          {Object.keys(filteredQuestions).length > 0 && (
            <>
              <h2 className="text-2xl font-semibold mb-2 text-center">
                Question Paper
              </h2>
              
              <h2 className="text-2xl font-semibold mb-4 text-red-600 text-center underline">
                Chapter : {chapterName}
              </h2>
              {Object.keys(filteredQuestions).map((categoryName, index) => (
                <div key={index} className="mb-4">
                  <h3 className="text-lg font-medium">{`Q${
                    index + 1
                  } ${categoryName}`}</h3>
                  <ul className="border ">
                    {filteredQuestions[categoryName].map(
                      (question, questionIndex) => (
                        <li key={questionIndex} className="mt-2 ml-6">
                          {/* Check if the question has hints */}
                          {filteredQuestions[categoryName].hints &&
                            filteredQuestions[categoryName].hints.length >
                              0 && (
                              <div className="mb-2">
                                <h4 className="font-medium">Hints:</h4>
                                <ul>
                                  {filteredQuestions[categoryName].hints.map(
                                    (hint, hintIndex) => (
                                      <li key={hintIndex}>{hint}</li>
                                    )
                                  )}
                                </ul>
                              </div>
                            )}
                          {question.question ? (
                            <p
                              className="font-medium"
                              onClick={() =>
                                handleQuestionSelection(categoryName, question)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              Q {question.index}: {question.question}
                            </p>
                          ) : question.imgUrl ? (
                            <div
                              className="mt-2 flex "
                              onClick={() =>
                                handleImageClick(question.imgUrl, categoryName)
                              }
                            > 
                             Q {question.index}:
                              <img
                              className=" h-auto"
                                src={question.imgUrl}
                                alt="Image Description"
                              />
                            </div>
                          ) : null}
                          {question.options && question.options.length > 0 && (
                            <div className="mt-2 flex justify-start items-start gap-5 flex-wrap">
                              {question.options.map((option, optionIndex) => (
                                <label key={optionIndex} className="block mb-2">
                                  <input
                                  disabled
                                    type="radio"
                                    name={`question${questionIndex}`}
                                    value={option}
                                    className="mr-2"
                                    style={{ display: 'none' }}
                                  />
                                  {option}
                                </label>
                              ))}
                            </div>
                          )}
                        </li>
                      )
                    )}
                  </ul>
                </div>
              ))}
            </>
          )}
        </div>
        <div className="border-l border-gray-300 pl-4">
          <CustomQuestionPaper setPrintContent={setPrintContent}
            selectedQuestions={uniqueSelectedQuestions}
            setSelectedQuestions={setSelectedQuestions}
          />
        </div>
      </div>
    </>
  );
};

export default QuestionPaper;
